import React from "react";
import ClosedCaptionsView from "./ClosedCaptionsView";

const ClosedCaptionsDesktopController = (params) => {
  return <ClosedCaptionsView msgSubCallback uiOptions={{}} />;
};

export default ClosedCaptionsDesktopController;
